












/* Created- 04 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { eParticaAction, ParticaEvent } from "../../../Models/ParticaEvent";
@Component(
	{
		name: "ArticleSlug"
	})
export default class ArticleSlug extends Vue {
	@Prop() private slug: string;
	private changed(event: any) {
		this.$emit("update:slug", event);
		this.$emit("partica-event", { action: eParticaAction.PROPERTY_CHANGED } as ParticaEvent);
	}

}
